const gcTourismStats = {
    name: 'gcTourismStats',
    src: 'https://www.statistics.gr/documents/20181/1515741/GreeceInFigures_2019Q2_EN.pdf/91b4306d-f9a8-1319-8dfb-8a4e2dc5d065',
    content: [
        {
            "id": "Kriti ",
            "label": "Kriti ",
            "value": 27.5,
            "color": "hsl(325, 70%, 50%)"
        },
        {
            "id": "Notio Aigaio",
            "label": "Notio Aigaio",
            "value": 24.0,
            "color": "hsl(1, 70%, 50%)"
        },
        {
            "id": "Ionia Nisia",
            "label": "Ionia Nisia",
            "value": 11.2,
            "color": "hsl(169, 70%, 50%)"
        },
        {
            "id": "Kentriki Makedonia",
            "label": "Kentriki Makedonia",
            "value": 10.9,
            "color": "hsl(169, 70%, 50%)"
        },
        {
            "id": "Attiki",
            "label": "Attiki",
            "value": 9.9,
            "color": "hsl(169, 70%, 50%)"
        },
        {
            "id": "Peloponnisos",
            "label": "Peloponnisos",
            "value": 3.8,
            "color": "hsl(169, 70%, 50%)"
        },
        {
            "id": "Thessalia",
            "label": "Thessalia",
            "value": 2.5,
            "color": "hsl(169, 70%, 50%)"
        },
        {
            "id": "Outras Regiões",
            "label": "Outras Regiões",
            "value": 10.2,
            "color": "hsl(169, 70%, 50%)"
        }
    ]
}

const gcTourismStats2 = {
    name: 'gcTourismStats2',
    src: 'https://www.statistics.gr/documents/20181/1515741/GreeceInFigures_2019Q2_EN.pdf/91b4306d-f9a8-1319-8dfb-8a4e2dc5d065',
    content: {
        index: "ano",
        values: ['ano', 'visitantes'],
        keys: ['visitantes'],
        data: [
            {
                "ano": "2010",
                "visitantes": 181746,
            },
            {
                "ano": "2011",
                "visitantes": 202139,
            },
            {
                "ano": "2012",
                "visitantes": 200271,
            },
            {
                "ano": "2013",
                "visitantes": 244449,
            },
            {
                "ano": "2014",
                "visitantes": 310416,
            },
            {
                "ano": "2015",
                "visitantes": 356443,
            },
            {
                "ano": "2016",
                "visitantes": 389817,
            },
            {
                "ano": "2017",
                "visitantes": 431183,
            },
            {
                "ano": "2018",
                "visitantes": 507213,
            },
        ]
    },
}

export {
    gcTourismStats,
    gcTourismStats2
}